import React from "react";

import { VERIFICATION_STATUS, VerificationStatus } from "models";

import { Form, Icon, Option, Select } from "components";

interface VerificationStatusDropdownProps {
  status: VerificationStatus;
  cropId: string;
  onStatusChange: (cropId: string, newStatus: VerificationStatus) => void;
  disabled?: boolean;
}

export const VerificationStatusDropdown = ({ status, cropId, onStatusChange, disabled = false }: VerificationStatusDropdownProps) => {
  const handleStatusChange = (newStatus: VerificationStatus) => {
    if (newStatus === status) return;
    onStatusChange(cropId, newStatus);
  };

  return (
    <Form name={`verification-form-${cropId}`}>
      {/* @ts-expect-error need to convert to tsx */}
      <Select
        name={`verification-status-${cropId}`}
        disabled={disabled}
        initialValue={status}
        onChange={handleStatusChange}
        className="verification-select"
        onClick={(e) => e.stopPropagation()}
      >
        <Option value={VERIFICATION_STATUS.autoApproved}>
          <span className="paragraph-m approved">
            <Icon iconName="tabler/circle-check" size="s" className="icon inline margin-right-25" />
            auto-approved
          </span>
        </Option>
        <Option value={VERIFICATION_STATUS.approved}>
          <span className="paragraph-m approved">
            <Icon iconName="tabler/circle-check" size="s" className="icon inline margin-right-25" />
            approved
          </span>
        </Option>
        <Option value={VERIFICATION_STATUS.pending}>
          <span className="paragraph-m">
            <Icon iconName="tabler/help" size="s" className="icon inline margin-right-25" />
            pending
          </span>
        </Option>
        <Option value={VERIFICATION_STATUS.rejected}>
          <span className="paragraph-m rejected">
            <Icon iconName="tabler/circle-x" size="s" className="icon inline margin-right-25" />
            rejected
          </span>
        </Option>
      </Select>
    </Form>
  );
};
